module.exports = __webpack_public_path__ + "static/media/header.218b56d3.jpg";